import React, { FC, ComponentProps } from 'react'

import './index.less'

export interface RiskRateProps extends ComponentProps<'div'> {
  status?: 'success' | 'error' | 'default' | 'processing' | 'warning'
  color?: string
  text?: string
  width?: number | string
  minWidth?: number | string
  maxWidth?: number | string
  count: number | string
}

export const RiskRate: FC<RiskRateProps> = (props) => {
  let { status, color, text, width, minWidth, maxWidth, count = 0 } = props

  const statusMap = {
    success: '#52c41a',
    error: '#ff4d4f',
    default: '#d9d9d9',
    processing: '#1890ff',
    warning: '#faad14',
  }

  if (status && ['success', 'error', 'default', 'processing', 'warning'].indexOf(status) > -1) {
    color = statusMap[status]
  }

  return (
    <div
      className="tntd-risk-rate"
      style={{
        width: width || '100px',
        minWidth: minWidth,
        maxWidth: maxWidth || width,
        borderColor: color,
      }}
    >
      <span
        className="tntd-risk-rate-score"
        style={{
          backgroundColor: color,
        }}
      >
        {count}
      </span>
      <span
        className="tntd-risk-rate-text"
        style={{
          color: color,
        }}
      >
        {text || '-'}
      </span>
    </div>
  )
}

RiskRate.displayName = 'RiskRate'

export default RiskRate
